/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { SOCIAL_NETWORK: de },
  'el-GR': { SOCIAL_NETWORK: el },
  'en-US': { SOCIAL_NETWORK: en },
  'es-ES': { SOCIAL_NETWORK: es },
  'fi-FI': { SOCIAL_NETWORK: fi },
  'fr-FR': { SOCIAL_NETWORK: fr },
  'it-IT': { SOCIAL_NETWORK: it },
  'pl-PL': { SOCIAL_NETWORK: pl },
  'pt-PT': { SOCIAL_NETWORK: pt }
};
